// Shared, cross-user governance queue. Unlike chat/notifications (which are
// per-user in sessionStore), approvals live in ONE queue: a request raised by
// any user is visible to — and actionable by — whichever admin is signed in.
// Each entry carries `requester: { user_id, name }` so the result can be routed
// back to whoever raised it. In-memory; cleared on a full page reload.

let approvals = []

export function getApprovals() {
  return approvals
}

export function addApproval(approval) {
  approvals = [approval, ...approvals]
  return approvals
}

export function removeApproval(id) {
  approvals = approvals.filter((a) => a.id !== id)
  return approvals
}
